const HYDRATION_ERROR_MARKERS = [
  "Minified React error #418",
  "Minified React error #423",
  "Minified React error #425",
  "react.dev/errors/418",
  "react.dev/errors/423",
  "react.dev/errors/425",
  "Hydration failed",
  "error while hydrating",
  "Text content does not match server-rendered HTML",
] as const;

export function isRecoverableHydrationErrorValue(value: string): boolean {
  return HYDRATION_ERROR_MARKERS.some((marker) => value.includes(marker));
}
